import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import RefreshIcon from '@mui/icons-material/Refresh';

function ErrorPage({ code, title, description, showRefresh = false }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        sx={{
          width: '100%',
          maxWidth: 520,
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" color="primary" fontWeight={700}>
          {code}
        </Typography>
        <Typography variant="h4" component="h1" sx={{ mt: 1, mb: 2 }}>
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button href="/" variant="contained" startIcon={<HomeIcon />}>
            {t('Go home')}
          </Button>
          {showRefresh && (
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={() => window.location.reload()}>
              {t('Refresh')}
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <ErrorPage
      code="404"
      title={t('Page not found')}
      description={t('The page you are looking for does not exist or has been moved.')}
    />
  );
}

export function ServerErrorPage() {
  const { t } = useTranslation();

  return (
    <ErrorPage
      code="500"
      title={t('Something went wrong')}
      description={t('An unexpected error occurred. Please refresh the page or try again later.')}
      showRefresh
    />
  );
}

export default ErrorPage;
